import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest, UpdatePartnerProfileRequest, UpdateUserProfile } from '@/types/request';
import { ApiResponse, PartnerProfile } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';

export class PartnerService {
    public async updateUserProfile(updateUserProfile: UpdateUserProfile, baseURL: string, userId?: string):
    Promise<ApiResponse<number>> {
        if (!userId) {
            userId = ObjectFactory.getCacheService().getSessionInfo().id;
        }
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_USERS}/${userId}/profile`,
            data: updateUserProfile,
            timeout: 50000,
            loaderEvent: {
                show: true,
            },
        };
        const response = await ObjectFactory.getHttpService().put<number>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async updatePartnerProfile(updatePartnerProfile: UpdatePartnerProfileRequest,
                                      baseURL: string): Promise<ApiResponse<string>> {
        const userId = ObjectFactory.getCacheService().getSessionInfo().id;
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_PARTNERS}/${userId}/profile`,
            data: updatePartnerProfile,
            timeout: 50000,
            loaderEvent: {
                show: true,
            },
        };
        const response = await ObjectFactory.getHttpService().put<string>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async getPartnerProfile(baseURL: string): Promise<ApiResponse<PartnerProfile>> {
        const userId = ObjectFactory.getCacheService().getSessionInfo().id;
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_PARTNERS}/${userId}`,
            timeout: 50000,
            loaderEvent: {
                show: true,
            },
        };
        const response = await ObjectFactory.getHttpService().get<PartnerProfile>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }
}
